module.exports = __webpack_public_path__ + "img/baseball-bat-ball.1b3b6578.svg";